import { render } from "./laundry.vue?vue&type=template&id=631e4e00"
import script from "./laundry.vue?vue&type=script&lang=js"
export * from "./laundry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__